<template>
  <div class="axj-post">
    <post-header
      @post-type-change="handlePostTypeChange"
      @create="handleCreate"
    />
    <school-post-main
      :data="tableData"
      v-show="postType=='院校张贴'"
      @update="handleUpdate"
      @delete="handleDeleteSchoolPost"
    ></school-post-main>
    <department-post-main
      @update="handleUpdate"
      :data="tableData"
      v-show="postType=='部门张贴'"
      @delete="handleDeleteDepartmentPost"
    />
    <post-footer
      :page-data="page"
      @page-change="handlePaginationChange"
    />
    <axj-post-edit
      @updated="handleUpdated"
      @created="handleCreated"
      :is-create="postEdit.create"
      :post-id="postEdit.postId"
      :show.sync="postEdit.show"
      :c-post-type="postType"
    />
  </div>
</template>

<script>
import PostHeader from "./component/post-header/index";
import PostFooter from "./component/post-footer/index";
import {listSchoolNotices,listDepartmentNotices,deleteSchoolNotices,deleteDepartmentNotices} from '@/api/axj-information/axj-information-post'
import SchoolPostMain from "./component/school-post-main/index";
import DepartmentPostMain from "./component/department-post-main/index";
import AxjPostEdit from "./action/axj-post-edit";
export default {
  name: "axj-post",
  components: {AxjPostEdit, DepartmentPostMain, SchoolPostMain, PostFooter, PostHeader},
  methods:{
    handleDeleteSchoolPost(id){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.deleteSchoolNotices(id)
        this.initSchoolData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    deleteSchoolNotices(id){
      return new Promise((resolve, reject)=>{
        deleteSchoolNotices(id).then(res=>{
          resolve()
        },error => {
        })
      })
    },

    handleUpdate(id){
      this.postEdit.postId=id
      this.postEdit.create=false
      this.postEdit.show=true
    },
    initSchoolData(){
      let user=this.$store.getters.getUser
      console.log(user)
      listSchoolNotices({
        preload:true,
        ...this.page,
        where:JSON.stringify({
          user_id:user.info.InfoUser.id
        })
      }).then(res=>{
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
      })
    },
    handlePaginationChange (val) {
      this.page = val
      if(this.postType==='院校张贴'){
        this.initSchoolData()
      }else{
        this.initDepartmentData()
      }
    },
    handleDeleteDepartmentPost(id){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.deleteDepartmentNotices(id)
        this.initDepartmentData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteDepartmentNotices(id){
      return new Promise((resolve, reject)=>{
        deleteDepartmentNotices(id).then(res=>{
          resolve()
        },error => {
        })
      })
    },
    initDepartmentData(){
      let user=this.$store.getters.getUser
      listDepartmentNotices({
        preload: true,
        ...this.page,
        where:JSON.stringify({
          user_id:user.info.InfoUser.id
        })
      }).then(res=>{
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
      },error=>{
        console.log(error)
      })
    },
    handlePostTypeChange(v){
      this.postType=v
      this.page.page=1
      if(v==='院校张贴'){
        this.initSchoolData()
      }else{
        this.initDepartmentData()
      }
    },
    handleCreate(){
      this.postEdit.create=true
      this.postEdit.show=true
    },
    handleUpdated(){
      this.postEdit.show=false
      if(this.postType==='院校张贴'){
        this.initSchoolData()
      }else{
        this.initDepartmentData()
      }
    },
    handleCreated(){
      this.postEdit.show=false
      if(this.postType==='院校张贴'){
        this.initSchoolData()
      }else{
        this.initDepartmentData()
      }
    }
  },
  created() {
    this.initSchoolData()
    let that=this
    window.handleNext=function (){
      if(that.page.page*that.page.limit<that.page.pageTotal){
        that.page.page=that.page.page+1
        that.handlePaginationChange(that.page)
      }
    }
    window.handlePre=function (){
      if(that.page.page>1){
        that.page.page=that.page.page-1
        that.handlePaginationChange(that.page)
      }
    }
  },
  data(){
    return{
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },
      postType:'院校张贴',
      postEdit:{
        create:true,
        show:false,
        postId:undefined
      }
    }
  }
}
</script>

<style scoped lang="scss">
.axj-post{

}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-post/index.vue